export default __webpack_public_path__ + "static/media/logo.e2636b86.svg";